import { Component, Inject } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { format } from 'date-fns';
import {
  EmploymentAvailabilityStatusEnum,
  UnavailabilityReasonEnum,
} from 'server/shared/models/user';
import { dbDayDateToken } from 'server/static/dbDayDateToken';
import { PermissionsService } from '../../../services/permissions.service';

export type EmploymentAvailabilityEditDialogData = {
  personName: string;
  availabilityId?: string;
  startDate?: string;
  endDate?: string;
  status?: EmploymentAvailabilityStatusEnum;
  notes?: string;
  unavailableReason?: UnavailabilityReasonEnum;
  workload?: number;
};
@Component({
  selector: 'temp-work-edit-availability-dialog',
  templateUrl: 'availability-edit-dialog.html',
  styleUrls: ['availability-edit-dialog.scss'],
})
export class EmploymentAvailabilityEditDialogComponent {
  unavailableReasonEnum = UnavailabilityReasonEnum;
  employmentAvailabilityStatusEnum = EmploymentAvailabilityStatusEnum;

  constructor(
    public dialogRef: MatDialogRef<EmploymentAvailabilityEditDialogComponent>,
    public permissionsService: PermissionsService,
    @Inject(MAT_DIALOG_DATA)
    public data: EmploymentAvailabilityEditDialogData,
  ) {}

  selectStartDate(event: MatDatepickerInputEvent<any & string>) {
    this.data.startDate = format(event.value, dbDayDateToken);
    if (this.data.endDate && this.data.endDate < this.data.startDate) {
      this.data.endDate = undefined;
    }
  }
  selectEndDate(event: MatDatepickerInputEvent<any & string>) {
    this.data.endDate = format(event.value, dbDayDateToken);
  }

  toggleAvailability() {
    if (this.data.status === EmploymentAvailabilityStatusEnum.AVAILABLE) {
      this.data.unavailableReason = undefined;
      if (!this.data.workload) {
        this.data.workload = 100;
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
